import { useTranslation } from 'react-i18next';

import styles from './RiskCenterStatus.module.scss';

const RiskCenterStatus = ({status}: {status: boolean}) => {
  const { t } = useTranslation();

  return status ? (
    <div className={styles['single-risk-center__status']} data-status-active={true}>
      {t('innerLayout.common.yes')}
    </div>
  ) : (
    <div className={styles['single-risk-center__status']} data-status-active={false}>
      {t('innerLayout.common.no')}
    </div>
  );
};

export default RiskCenterStatus;